import {ParameterValidator} from '@mvps-genesis/utilities';
import MicroModal from 'micromodal';
import {HTMLFormValidator} from '@mvps-genesis/form-validation';

export default class WaitListAdd {

	constructor (
		formElement,
		{
			submitButtonElement = '.x-product-card__atc-waitlist',
			waitData = '.x-product-card__atc-form'
		} = {}
	) {

		// Create validator
		this._validator = new ParameterValidator(this);

		// Set properties from options
		this.formElement = formElement;
		this.waitData = this._validator.isElement('options.waitData', waitData, {container: formElement});
		this.submitButtonElement = this._validator.isElement('options.submitButtonElement', submitButtonElement, {container: formElement});

		// Run bootstrap functions
		this.bindEvents();
	}

	bindEvents () {

		document.getElementById('wreview_form').addEventListener('submit', this.onSubmit.bind(this), false);
		this.submitButtonElement.addEventListener('click', this.onClick.bind(this), false);
	}

	// eslint-disable-next-line max-lines-per-function
	onClick () {

		var globalModal = document.getElementById('js-global-modal'),
			globalModalContent = globalModal.getElementsByClassName('c-micromodal__content')[0],
			waitForm = document.getElementById('wreview_form'),
			waitProdCode = this.waitData.dataset.gtmCode ? this.waitData.dataset.gtmCode : '',
			waitProdName = this.waitData.dataset.gtmName ? this.waitData.dataset.gtmName : '',
			waitProdNamePlaceholder = document.getElementById('js-wait-prodname');

		waitForm.reset();
		waitForm.querySelector('#js-wait-message').innerHTML = '';
		waitForm.querySelector('#js-wait-message').classList.add('u-hidden');
		waitForm.action = '';
		waitForm.action = window.location.origin + `/mm5/json.mvc?Module_Code=TGWaitlist&Store_Code=MVL&Function=Module&Module_Function=Waitlist_API&WaitlistFunction=Waitlist_Add&Product_Code=`;
		waitProdNamePlaceholder.innerHTML = waitProdName;
		waitForm.elements.Product_Code.value = waitProdCode;
		waitForm.classList.remove('u-hidden');

		// Create a new Validator form instance
		if (waitForm !== null) {
			new HTMLFormValidator({
				formElement: waitForm,
				wrapperSelector: '.c-form-list__item'
			});
		}
		globalModal.querySelector('.c-micromodal__container').classList.add('x-modal__container_wait');
		globalModal.querySelector('.c-micromodal__close-button').classList.add('x-modal__close', 'c-button', 'c-button--icon', 'c-button--clear', 'u-color-black');

		const showWaitlistForm = function () {

			MicroModal.show('js-global-modal', {
				awaitCloseAnimation: true,
				closeTrigger: 'data-micromodal-close',
				disableFocus: true,
				disableScroll: true,
				onClose: function () {
					document.querySelector('body').classList.remove('c-micromodal__open');
					globalModal.querySelector('.c-micromodal__container').classList.remove('x-modal__container_wait');
				},
				onShow: function () {
					globalModalContent.innerHTML = '';
					let wishContainer = document.createElement('div');
					wishContainer.classList.add('wishlist-wrapper');
					wishContainer.appendChild(waitForm);
					globalModalContent.appendChild(wishContainer);
					document.querySelector('body').classList.add('c-micromodal__open');
				}
			});
		};

		waitForm.classList.remove('u-hidden');
		showWaitlistForm();
	}

	// eslint-disable-next-line max-lines-per-function
	onSubmit (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		var waitResponseMessage = '';
		const waitForm = document.getElementById('wreview_form');
		const formData = new FormData(waitForm),
			request = new XMLHttpRequest(),
			waitMessageContainer = waitForm.querySelector('#js-wait-message'),
			waitProdCode = waitForm.elements.Product_Code.value,
			waitProdEmail = waitForm.elements.Email.value,
			waitSubmitBtn = waitForm.querySelector('button[type="submit"]');

		waitForm.action += waitProdCode + `&Email=` + waitProdEmail;

		// Set idle status
		waitForm.dataset.status = 'idle';
		if (waitForm.dataset.status !== 'processing') {

			// Set status while processing
			waitForm.dataset.status = 'processing';

			// Disable button while processing
			waitSubmitBtn.disabled = true;

			// Set text of button to processing
			waitSubmitBtn.innerText = 'Processing...';

			// Clear response message
			waitMessageContainer.innerHTML = '';

			// Handle readystatechange callback
			request.onreadystatechange = () => {

				// Only run if the request is complete
				if (request.readyState !== 4) {
					return;
				}
				if (request.status === 200) {
					waitResponseMessage = JSON.parse(request.responseText);

					if (waitResponseMessage.success === 0) {
						waitMessageContainer.classList.remove('u-hidden');
						if (waitResponseMessage.error_message.includes('Missing Email') || waitResponseMessage.error_message.includes('already on the Waitlist')) {
							waitMessageContainer.classList.remove('x-messages--success', 'x-messages--info', 'x-messages--error');
							waitMessageContainer.classList.add('x-messages--error');
						}
						waitMessageContainer.textContent = waitResponseMessage.error_message;
					}
					else {
						waitMessageContainer.classList.remove('u-hidden');
						waitMessageContainer.classList.remove('x-messages--error', 'x-messages--info', 'x-messages--success');
						waitMessageContainer.classList.add('x-messages--success');
						waitMessageContainer.textContent = 'Thank you for signing up!';
					}
				} else {
					waitMessageContainer.classList.remove('u-hidden');
					waitMessageContainer.classList.remove('x-messages--success', 'x-messages--info', 'x-messages--error');
					waitMessageContainer.classList.add('x-messages--error');
					waitMessageContainer.textContent = 'An error has occurred.';
				}

				waitForm.dataset.status = 'idle';
				waitSubmitBtn.innerText = 'Notify Me';
				waitSubmitBtn.disabled = false;
			};

			/**
			 * Create and send a request
			 * The first argument is the post type (GET, POST, PUT, DELETE, etc.)
			 * The second argument is the endpoint URL
			 */
			request.open(waitForm.method, waitForm.action, true);
			request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			request.send(formData);

			waitForm.removeAttribute('action');
			waitForm.action = window.location.origin + `/mm5/json.mvc?Module_Code=TGWaitlist&Store_Code=MVL&Function=Module&Module_Function=Waitlist_API&WaitlistFunction=Waitlist_Add&Product_Code=`;
		}
	}
};
